import kaapiImg1 from "../assets/images/products/kaapi-1.jpg";
import kaapiImg2 from "../assets/images/products/kaapi-2.jpg";
import kaapiImg3 from "../assets/images/products/kaapi-3.jpg";
import kaapiImg4 from "../assets/images/products/kaapi-4.png";
import kaapiImg5 from "../assets/images/products/kaapi-5.jpg";
import kaapiImg6 from "../assets/images/products/kaapi-6.jpg";
import kaapiImg7 from "../assets/images/products/kaapi-7.jpg";

export const GROUND_COFFEE_PRODUCTS = {
  201: {
    _id: 201,
    id: 201,
    productName: "KAAPI",
    price: 299,
    gram: "180g",
    images: [
      kaapiImg1,
      kaapiImg2,
      kaapiImg3,
      kaapiImg4,
      kaapiImg5,
      kaapiImg6,
      kaapiImg7,
    ],
    stock: 50,
    numOfReviews: 0,
    comingSoon: false,
    productDescription: `<p>KAAPI is our signature South Indian filter coffee powder. A carefully balanced blend of high-quality Arabica and Robusta coffee beans, expertly roasted and mixed with chicory to create a harmonious flavor profile. Experience the Rich Flavor of South Indian Filter Coffee.</p>
<p>KAAPI is renowned for its unique brewing method and the use of chicory to enhance the aroma and texture. Our KAAPI brings this tradition to your cup. It is easy to use with a traditional South Indian coffee filter or even a drip machine. The moment you open the seal, you'll be greeted by the tantalizing aroma of freshly ground coffee and chicory. It's a sensory experience that sets the stage for a delightful coffee journey.</p>`,
  },
};

export function getGroundCoffeeProduct(id) {
  return GROUND_COFFEE_PRODUCTS[id];
}
